import React from "react";
import { components } from 'react-select';
import CreateReactSelect from 'react-select/creatable';

const DynamicDropdown = ({ onChangeHandler, item, index, parentData,placeholder,value }) => {
  const searchTypeCustomStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: 38,
      width: "100%",
      backgroundColor: '#fff',
      borderRadius: '4px',
      fontSize: '14px',
      fontWeight: 600,
      textAlign: 'left',
      border: 'none',
      outline: state.isFocused ? "1px solid #6F08F1" : "1px solid #e4e7eb",
      '&:hover': {
        outline: '1px solid #6F08F1',
      }
    }),
    menu: base => ({
      ...base,
      fontSize: '14px',
    }),
    multiValue: base => ({
      ...base,
      fontWeight: '400'
    }),
    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        color: 'darkgray',
        fontWeight: 400,
      }
    },

    MultiValueRemove: (defaultStyles) => ({
      ...defaultStyles,
      backgroundColor: "#E2D9FC",
      color: '#6F08F1',
    }),
    option: (base, { isDisabled, isFocused, isSelected, isHovered }) => ({
      ...base,
      backgroundColor: null,
      color: isDisabled ? null : isSelected ? "#1a1722" : isFocused ? '#1a1722' : null,
      cursor: 'pointer !important',
    })
  }

  const parentCustomComponents = {
    IndicatorSeparator: () => null,
    DropdownIndicator: () => null,
    NoOptionsMessage: (props) => <components.NoOptionsMessage {...props}>
      <p className="text-left mb-0">Please enter {placeholder}</p>
    </components.NoOptionsMessage>
  };

  return <div>
    <CreateReactSelect
      isMulti
      components={parentCustomComponents}
      styles={searchTypeCustomStyles}
      onChange={(value) => {
        onChangeHandler(value, item, index, parentData)
      }}
      value={value}
      placeholder={placeholder}
    />
  </div>;
};

export default DynamicDropdown;
